const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => {state.tagsView.visitedViews},
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  userInfo: state => state.userInfo,
  // 账号改造：用户类型（PERSONAL / ENTERPRISE / ENTERPRISE_ROOT）
  accountUserType: state => state.accountUserType,
  carrier_param: state => state.carrier_param,
  SchemaTree: state => state.SchemaTree,
  carrierTree: state => state.carrierTree,
  CURRENT_SYSTEM_MENU: state => state.CURRENT_SYSTEM_MENU,
  APPLICATIONFN:state=>state.guide.application,




  // brian 2022 04 23

  switch_scope:state =>state.userInfo.switchScope
}
export default getters
